import Icon from 'veui/components/Icon'
import { IconArrowRight } from 'dls-icons-vue'

Icon.register('arrow-right', IconArrowRight)
